document.addEventListener("contextmenu", function (e) {
  // if (process.env.ENV !== "local") {
  //   e.preventDefault();
  // }
});
